module.exports = __webpack_public_path__ + "img/about-bcfn-header.png?58e7775b453a5422093de946a2edffc1";